import request from '@/utils/request'

export function updateAttackCoinCfg(data) {
  return request({
    url: 'api/v1/attack-coin/updateAttackCoinCfg',
    method: 'post',
    data: data
  })
}

export function getAttackCoinCfgList(data) {
  return request({
    url: 'api/v1/attack-coin/getAttackCoinCfg',
    method: 'post',
    data: data
  })
}

export function exportAttackCoinCfg() {
  return request({
    url: 'api/v1/attack-coin/export',
    method: 'get' })
}

export function importAttackCoinCfg(data) {
  return request({
    url: 'api/v1/attack-coin/import',
    method: 'post',
    data: data
  })
}

export function delAttackCoinCfg(data) {
  return request({
    url: 'api/v1/attack-coin/del',
    method: 'delete',
    data: data
  })
}

